import produce from "immer";
import { ActionType } from "typesafe-actions";
import { IStoreState } from "..";
import { LoadState } from "../../constants/enums";
import * as Actions from "./MaterialRequest.actions";
import {
  defaultMaterialRequest,
  defaultMaterialRequestState,
} from "./MaterialRequest.state";

export type IMaterialRequestActions = ActionType<typeof Actions>;

export const materialRequestReducer = (
  state: IStoreState["material_request"] = defaultMaterialRequestState,
  action: IMaterialRequestActions,
) => {
  switch (action.type) {
    case Actions.FETCH_MATERIAL_REQUEST_LIST_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.material_request_list.loading = LoadState.InProgress;
        draftState.material_request_list.data = [];
        draftState.material_request_list.totalRecords = 0;
      });
    }
    case Actions.FETCH_MATERIAL_REQUEST_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      return produce(state, (draftState) => {
        draftState.material_request_list.loading = LoadState.Loaded;
        draftState.material_request_list.data = list;
        draftState.material_request_list.totalRecords = totalRecords;
      });
    }
    case Actions.FETCH_MATERIAL_REQUEST_LIST_FAILED: {
      return produce(state, (draftState) => {
        draftState.material_request_list.loading = LoadState.Failed;
        draftState.material_request_list.data = [];
        draftState.material_request_list.totalRecords = 0;
      });
    }

    case Actions.FETCH_SINGLE_MATERIAL_REQUEST_PROGRESS: {
      return produce(state, (draftState) => {
        draftState.single_material_request.loading = LoadState.InProgress;
      });
    }
    case Actions.FETCH_SINGLE_MATERIAL_REQUEST_SUCCESS: {
      const { data } = action.payload;
      return produce(state, (draftState) => {
        draftState.single_material_request.loading = LoadState.Loaded;
        draftState.single_material_request.data = data;
        draftState.single_material_request.error = null;
      });
    }
    case Actions.FETCH_SINGLE_MATERIAL_REQUEST_FAILED: {
      const { errorMessage } = action.payload;
      return produce(state, (draftState) => {
        draftState.single_material_request.loading = LoadState.Failed;
        draftState.single_material_request.error = errorMessage;
      });
    }

    case Actions.CLEAR_SINGLE_MATERIAL_REQUEST: {
      return produce(state, (draftState) => {
        draftState.single_material_request.loading = LoadState.NotLoaded;
        draftState.single_material_request.data = defaultMaterialRequest;
        draftState.single_material_request.error = null;
      });
    }

    case Actions.CLEAR_MATERIAL_REQUEST_STATE: {
      return defaultMaterialRequestState;
    }

    default: {
      return state;
    }
  }
};
